import React, { Component } from "react"
import classnames from "classnames"
import { ContextLayout } from "@utils/context/Layout"
import SidebarHeader from "./SidebarHeader"
import SideMenuContent from "./sidemenu/SideMenuContent"
import PerfectScrollbar from "react-perfect-scrollbar"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { history } from "@src/history"
class Sidebar extends Component {
  static getDerivedStateFromProps(props, state) {
    if (props.activePath !== state.activeItem) {
      return {
        activeItem: props.activePath
      }
    }
    // Return null if the state hasn't changed
    return null
  }
  state = {
    width: window.innerWidth,
    activeIndex: null,
    hoveredMenuItem: null,
    activeItem: this.props.activePath,
    menuShadow: false,
    showSidebar: false,
    showFilterSidebar:true,
    ScrollbarTag: PerfectScrollbar,
    showDropdown: false,
    showProfileDropdown:false,
    showInventory:false,
    showMarket:false,
    showPlay:false
  }

  mounted = false

  updateWidth = () => {
    if (this.mounted) {
      this.setState(prevState => ({
        width: window.innerWidth
      }))
      this.checkDevice()
    }
  }

  componentDidMount() {
    this.mounted = true
    if (this.mounted) {
      if (typeof window !== "undefined") {
        window.addEventListener("resize", this.updateWidth, false)
      }
      this.checkDevice()
    }
  }

  componentWillUnmount() {
    this.mounted = false
  }

  checkDevice = () => {
    var prefixes = " -webkit- -moz- -o- -ms- ".split(" ")
    var mq = function(query) {
      return window.matchMedia(query).matches
    }

    if ("ontouchstart" in window || window.DocumentTouch) {
      this.setState({
        ScrollbarTag: "div"
      })
    } else {
      this.setState({
        ScrollbarTag: PerfectScrollbar
      })
    }
    var query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("")
    return mq(query)
  }

  changeActiveIndex = id => {
    if (id !== this.state.activeIndex) {
      this.setState({
        activeIndex: id
      })
    } else {
      this.setState({
        activeIndex: null
      })
    }
  }

  handleSidebarMouseEnter = id => {
    if (id !== this.state.hoveredMenuItem) {
      this.setState({
        hoveredMenuItem: id
      })
    } else {
      this.setState({
        hoveredMenuItem: null
      })
    }
  }

  handleActiveItem = url => {
    this.setState({
      activeItem: url
    })
  }

  scrollShadow = (container, dir) => {
    if (container && dir === "up" && container.scrollTop >= 100) {
      this.setState({ menuShadow: true })
    } else if (container && dir === "down" && container.scrollTop < 100) {
      this.setState({ menuShadow: false })
    } else {
      return
    }
  }

  toggleSidebar = () => {
    this.setState({showSidebar: !this.state.showSidebar,showDropdown:false,showProfileDropdown:false,showInventory:false,showMarket:false,showPlay:false})
  }

   toggleDropdown = () => this.setState({showDropdown:!this.state.showDropdown});
   toggleProfileDropdown = () => this.setState({showProfileDropdown:!this.state.showProfileDropdown});
   toggleInventory = () => this.setState({showInventory:!this.state.showInventory});
   toggleMarket = () => this.setState({showMarket:!this.state.showMarket});
   togglePlay = () => this.setState({showPlay:!this.state.showPlay});

  render() {
    let {
      visibilityState,
      toggleSidebarMenu,
      sidebarHover,
      toggle,
      color,
      sidebarVisibility,
      activeTheme,
      collapsed,
      activePath,
      sidebarState,
      currentLang,
      permission,
      collapsedMenuPaths,
      
    } = this.props

    let {
      menuShadow,
      activeIndex,
      hoveredMenuItem,
      activeItem,
      ScrollbarTag
    } = this.state

    return (
      <ContextLayout.Consumer>
        {context => {
          let dir = context.state.direction
          
          return (
            <React.Fragment>
              {window.innerWidth < 768 && ['/market', '/arcadex', '/leaderboard','/boosting_assets','/cards','/library', '/mining','/','/auctions','/ingredients'].includes(window.location.pathname)&& 
              <div>
                <div className="divider"></div>
                    <button className="btn side-btn" onClick={this.toggleSidebar}>
                        <span>
                        <svg className="menu-icon"><use href="/img/menu.svg#icon-menu_icon" fill="#FFFFFF"/></svg>
                        </span>
                      </button></div>}
              {(!['/market', '/arcadex', '/leaderboard','/boosting_assets','/cards','/library', '/mining','/','/auctions','/ingredients'].includes(window.location.pathname)) &&<div>
                <div className="divider"></div>
                    <button className="btn side-btn" onClick={this.toggleSidebar}>
                        <span>
                        <svg className="menu-icon"><use href="/img/menu.svg#icon-menu_icon" fill="#FFFFFF"/></svg>
                        </span>
                      </button></div>
                      }
                      
              { this.state.showSidebar  ? 
              <div className={classnames(
                  `sidenav-overlay theme-${activeTheme}`,
                  {
                    collapsed: sidebarState === true,
                    "hide-sidebar":
                      this.state.width < 1200 && visibilityState === false
                  }
                )}
                onMouseEnter={() => sidebarHover(false)}
                onMouseLeave={() => sidebarHover(true)}>
                  

                <SidebarHeader
                  toggleSidebarMenu={toggleSidebarMenu}
                  toggle={toggle}
                  sidebarBgColor={color}
                  sidebarVisibility={sidebarVisibility}
                  activeTheme={activeTheme}
                  collapsed={collapsed}
                  menuShadow={menuShadow}
                  activePath={activePath}
                  sidebarState={sidebarState}
                  toggleSidebar={this.toggleSidebar}
                  showSidebar={this.state.showSidebar}
                />
                <ScrollbarTag
                  className={classnames("main-menu-content", {
                    "overflow-hidden": ScrollbarTag !== "div",
                    "overflow-auto": ScrollbarTag === "div"
                  })}
                  {...(ScrollbarTag !== "div" && {
                    options: { wheelPropagation: false },
                    onScrollDown: container => this.scrollShadow(container, "down"),
                    onScrollUp: container => this.scrollShadow(container, "up"),
                    onYReachStart: () =>
                      menuShadow === true &&
                      this.setState({ menuShadow: false })
                  })}>
                    <ul className="navigation navigation-main" style={{background:'transparent',padding:'0',margin:'0'}}>
                      <div className={"side-btn-content first-child"+(window.location.pathname === '/' ? ' active' : '')} 
                      onClick={()=>{history.push("/")}}
                      >HOME</div>
                      <div 
                        style={{opacity: `${this.state.showInventory && '1'}`}}
                        onClick={this.toggleInventory} 
                        className={"side-btn-content side-btn_dropdown "+(['/cards','/wallet','/ingredients'].includes(window.location.pathname) ? 'active' : '')}>
                          My Inventory
                          <FontAwesomeIcon icon={!this.state.showInventory ? faAngleDown : faAngleUp} className="icon_arrow_mobile"/>   
                        </div>
                          {this.state.showInventory && 
                            <>
                              <div
                                className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/cards' ? 'active' : '')}
                                onClick={()=>{
                                  this.toggleSidebar()
                                  history.push("/cards")}}>
                                  My Cards
                                </div>

                                <div
                                  className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/wallet' ? 'active' : '')}
                                  onClick={()=>{
                                    this.toggleSidebar()
                                    history.push("/wallet")}}>
                                    Wallet
                                </div>
                                <div
                                  className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/arcadex' ? 'active' : '')}
                                  onClick={()=>{
                                    this.toggleSidebar()
                                    history.push("/arcadex")}}>
                                    My arcadex
                                </div>
                            </>
                          }
                      <div 
                        style={{opacity: `${this.state.showPlay && '1'}`}}
                        onClick={this.togglePlay} 
                        className={"side-btn-content side-btn_dropdown "+(['/mining','/mining_grid','/shadow_depths'].includes(window.location.pathname) ? 'active' : '')}>
                          Play
                          <FontAwesomeIcon icon={!this.state.showPlay ? faAngleDown : faAngleUp} className="icon_arrow_mobile"/>   
                        </div>
                          {this.state.showPlay && 
                            <>
                              <div
                                className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/mining' ? 'active' : '')}
                                onClick={()=>{
                                  this.toggleSidebar()
                                  history.push("/mining")}}>
                                  Arcadian Mining
                                </div>

                                <div
                                  className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/mining_grid' ? 'active' : '')}
                                  onClick={()=>{
                                    this.toggleSidebar()
                                    history.push("/mining_grid")}}>
                                    Apertian region
                                </div>
                                <div
                                  className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/shadow_depths' ? 'active' : '')}
                                  onClick={()=>{
                                    this.toggleSidebar()
                                    history.push("/shadow_depths")}}>
                                    Shadow depths
                                </div>
                            </>
                          }
                      <div 
                        style={{opacity: `${this.state.showMarket && '1'}`}}
                        onClick={this.toggleMarket} 
                        className={"side-btn-content side-btn_dropdown "+(['/market','/market_sales','/market_sales_weekly','/market_sales_monthly'].includes(window.location.pathname) ? 'active' : '')}>
                          Market
                          <FontAwesomeIcon icon={!this.state.showMarket ? faAngleDown : faAngleUp} className="icon_arrow_mobile"/>   
                        </div>
                          {this.state.showMarket && 
                            <>
                              <div
                                className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/market' ? 'active' : '')}
                                onClick={()=>{
                                  this.toggleSidebar()
                                  history.push("/market")}}>
                                  Marketplace
                                </div>
                                <div
                                className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/shop' ? 'active' : '')}
                                onClick={()=>{
                                  this.toggleSidebar()
                                  history.push("/shop")}}>
                                  NBM Shop
                                </div>

                                <div
                                  className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/market_sales' ? 'active' : '')}
                                  onClick={()=>{
                                    this.toggleSidebar()
                                    history.push("/market_sales")}}>
                                    History
                                </div>
                                 <div
                                  className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/market_sales_weekly' ? 'active' : '')}
                                  onClick={()=>{
                                    this.toggleSidebar()
                                    history.push("/market_sales_weekly")}}>
                                    Weekly Leaderboard
                                </div>
                                <div
                                  className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/market_sales_monthly' ? 'active' : '')}
                                  onClick={()=>{
                                    this.toggleSidebar()
                                    history.push("/market_sales_monthly")}}>
                                    Monthly Leaderboard
                                </div>
                            </>
                          }

                      <div 
                        style={{opacity: `${this.state.showDropdown && '1'}`}}
                        onClick={this.toggleDropdown} 
                        className={"side-btn-content side-btn_dropdown "+(['/tutorials','/library','/mining_calc'].includes(window.location.pathname) ? 'active' : '')}>
                          NBM Academy
                          <FontAwesomeIcon icon={!this.state.showDropdown ? faAngleDown : faAngleUp} className="icon_arrow_mobile"/>   
                        </div>
                          {this.state.showDropdown && 
                            <>
                              <div
                                className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/tutorials' ? 'active' : '')}
                                onClick={()=>{
                                  this.toggleSidebar()
                                  history.push("/tutorials")}}>
                                  Tutorials
                                </div>
                                <a target="_blank"
                                  href = "https://nbmofficialwiki.gitbook.io/nbm-shadow-depths/ "
                                  className={"side-btn-content side-btn-dropdown "}
                                  onClick={()=>{this.toggleSidebar()}}>
                                  NBM Wiki
                                </a>

                                <div
                                  className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/library' ? 'active' : '')}
                                  onClick={()=>{
                                    this.toggleSidebar()
                                    history.push("/library")}}>
                                    NBM Library
                                </div>
                                <div
                                  className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/mining_calc' ? 'active' : '')}
                                  onClick={()=>{
                                    this.toggleSidebar()
                                    history.push("/mining_calc")}}>
                                    Calculator
                                </div>
                            </>
                          }
                        <div 
                        style={{opacity: `${this.state.showProfileDropdown && '1'}`}}
                        onClick={this.toggleProfileDropdown} 
                        className={"side-btn-content side-btn_dropdown "+(['/profile','/ranks','/achievements'].includes(window.location.pathname) ? 'active' : '')}>
                          Profile
                          <FontAwesomeIcon icon={!this.state.showProfileDropdown ? faAngleDown : faAngleUp} className="icon_arrow_mobile"/>   
                        </div>
                          {this.state.showProfileDropdown && 
                            <>
                              <div
                                className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/profile' ? 'active' : '')}
                                onClick={()=>{
                                  this.toggleSidebar()
                                  history.push("/profile")}}>
                                  profile
                                </div>

                                <div
                                  className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/ranks' ? 'active' : '')}
                                  onClick={()=>{
                                    this.toggleSidebar()
                                    history.push("/ranks")}}>
                                    Ranks
                                </div>
                                <div
                                  className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/achievements' ? 'active' : '')}
                                  onClick={()=>{
                                    this.toggleSidebar()
                                    history.push("/achievements")}}>
                                    Achievements
                                </div>
                                <div
                                  className={"side-btn-content side-btn-dropdown "+(window.location.pathname === '/rank_rolls' ? 'active' : '')}
                                  onClick={()=>{
                                    this.toggleSidebar()
                                    history.push("/rank_rolls")}}>
                                    Rank Rolls
                                </div>
                            </>
                          }
                      {false && <div className={"side-btn-content"+(window.location.pathname === '/pvp' ? ' active' : '')} 
                      onClick={()=>{history.push("/pvp")}}
                      >PVP</div>}
                      <div className={"side-btn-content"+(window.location.pathname === '/leaderboard' ? ' active' : '')} 
                      onClick={()=>{history.push("/leaderboard")}}
                      >LEADERBOARD</div>
                      <div className={"side-btn-content"+(window.location.pathname === '/arcadia' ? ' active' : '')} 
                      onClick={()=>{history.push("/arcadia")}}
                      >Arcadia</div>
                      <div className={"side-btn-content"+(window.location.pathname === '/packs' ? ' active' : '')} 
                      onClick={()=>{history.push("/packs")}}
                      >PACK OPENING</div>
                      <div className={"side-btn-content"+(window.location.pathname === '/shop' ? ' active' : '')} 
                      onClick={()=>{history.push("/shop")}}
                      >NBM SHOP</div>
                      <div className={"side-btn-content"+(window.location.pathname === '/blending' ? ' active' : '')} 
                      onClick={()=>{history.push("/blending")}}
                      >BLENDING</div>
                      <div className={"side-btn-content"+(window.location.pathname === '/asset_search' ? ' active' : '')} 
                      onClick={()=>{history.push("/asset_search")}}
                      >ASSET SEARCH</div>
                      <div className={"side-btn-content"+(window.location.pathname === '/mining_operation_search' ? ' active' : '')} 
                      onClick={()=>{history.push("/mining_operation_search")}}
                      >MINING OPERATION SEARCH</div>
                      <div className={"side-btn-content"+(window.location.pathname === '/votings' ? ' active' : '')} 
                      onClick={()=>{history.push("/votings")}}
                      >VOTING PLACE</div>
                      <div className={"side-btn-content"+(window.location.pathname === '/sales' ? ' active' : '')} 
                      onClick={()=>{history.push("/sales")}}
                      >SALES</div>
                      <div className={"side-btn-content"+(window.location.pathname === '/partners_pool' ? ' active' : '')} 
                      onClick={()=>{history.push("/partners_pool")}}
                      >PARTNERSHIP POOL</div>
                      <div className={"side-btn-content"+(window.location.pathname === '/boosting_assets' ? ' active' : '')} 
                      onClick={()=>{history.push("/boosting_assets")}}
                      >PARTNER BOOSTS</div>
                      <div className={"side-btn-content"+(window.location.pathname === '/lucky_draw' ? ' active' : '')} 
                      onClick={()=>{history.push("/lucky_draw")}}
                      >LUCKY DRAW</div>
                      <div className="side-btn-content" onClick={() => {window.location.href ='https://nftbattleminers.com'}}
                      >WEB SITE</div>
                      <SideMenuContent
                        setActiveIndex={this.changeActiveIndex}
                        activeIndex={activeIndex}
                        hoverIndex={hoveredMenuItem}
                        handleSidebarMouseEnter={this.handleSidebarMouseEnter}
                        activeItemState={activeItem}
                        handleActiveItem={this.handleActiveItem}
                        activePath={activePath}
                        lang={currentLang}
                        permission={permission}
                        collapsedMenuPaths={collapsedMenuPaths}
                        toggleMenu={sidebarVisibility}
                        deviceWidth={this.props.deviceWidth}
                      />
                      <SideMenuContent/>
                    </ul>
                </ScrollbarTag>
              </div>:null}
            </React.Fragment>
          )
        }}
      </ContextLayout.Consumer>
    )
  }
}

export default Sidebar
